export function undefinedIfEmpty(value: unknown): string | undefined {
	return typeof value === 'string' ? (value.length === 0 ? undefined : value) : undefined;
}
